/*
 * Jira Ticket:
 * Created Date: Thu, 9th Jul 2020, 16:25:06 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

export default plan => {
  // if we ever add locale, will need to use here
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: plan.currencyCode,
  }).format(plan.amount);
};
